import { useEffect, useState } from "react";
import { DEFAULT_MARKETPLACE_RANGE } from "../../../../constants/automapMarketplaceAnalyticsConstants";
import { fetchTrustSafetyMarketplaceAnalytics } from "../../../../services/automapMarketplaceAnalyticsApi";
import { AnalyticsBreakdownTable, AnalyticsSummaryGrid } from "../AdminAnalyticsShared";
import { ActionLinksPanel, MarketplaceAnalyticsShell } from "./AdminMarketplaceAnalyticsShared";

export default function AdminTrustSafetyAnalyticsPage() {
  const [range, setRange] = useState(DEFAULT_MARKETPLACE_RANGE);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchTrustSafetyMarketplaceAnalytics(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar analytics."))
      .finally(() => setLoading(false));
  }, [range]);

  const totals = payload?.totals;

  return (
    <MarketplaceAnalyticsShell
      active="trust-safety"
      title="Confianza y seguridad"
      description="Casos abiertos, reportes y dealers con problemas recurrentes."
      range={range}
      onRangeChange={setRange}
      viewEvent="trust_safety_analytics_viewed"
    >
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error && totals ? (
        <>
          <AnalyticsSummaryGrid
            items={[
              { label: "Casos abiertos", value: totals.openCases },
              { label: "Reportes nuevos", value: totals.newReports },
              { label: "Críticos", value: totals.criticalCases },
              { label: "Alta severidad", value: totals.highCases },
              {
                label: "Tiempo resolución",
                value: "—",
                hint: payload.resolutionTimeNote,
              },
            ]}
          />
          <ActionLinksPanel links={payload.actionLinks} />
          <div className="admin-analytics-grid">
            <AnalyticsBreakdownTable title="Por tipo" rows={payload.byType} keyLabel="Tipo" />
            <AnalyticsBreakdownTable title="Por categoría" rows={payload.byCategory} keyLabel="Categoría" />
            <AnalyticsBreakdownTable title="Dealers recurrentes" rows={payload.repeatIssueDealers} keyLabel="Dealer" />
          </div>
        </>
      ) : null}
    </MarketplaceAnalyticsShell>
  );
}
